import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BaseStoreFacade } from '@city/data-access';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { InstanceUidService } from '@core/feature';
import { OCC_ENDPOINTS } from '@promo/const';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

export interface MailSubscriptionPayload {
  baseStore: string;
  email: string;
  instanceUid: string;
}

@Injectable({
  providedIn: 'root',
})
export class OccMailSubscriptionService {
  private readonly http = inject(HttpClient);
  private readonly occEndpointsService = inject(OccEndpointsService);
  private readonly instanceUidService = inject(InstanceUidService);
  private readonly baseStoreFacade = inject(BaseStoreFacade);

  subscribe(email: string, captchaToken?: string): Observable<void> {
    return this.baseStoreFacade.getActiveCode().pipe(
      take(1),
      switchMap((baseStore) => {
        const instanceUid = this.instanceUidService.getInstanceUidFormCookie() ?? '';
        const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.anonymousSubscription);
        const body: MailSubscriptionPayload = { baseStore, email, instanceUid };

        return this.http.post<void>(url, body, {
          params: captchaToken ? { token: captchaToken } : {},
          context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.anonymousSubscription),
        });
      }),
    );
  }
}
